import React from "react";
import type { MetatagMap, TagType } from "../../app/core/lib/tagging/type";

export function renderMetaTags(metatags: MetatagMap) {
    if (metatags) {
        const tags = Array.from(metatags.values());

        return tags.map((tag: TagType, i) => {
            if (tag.type === "meta") {
                const metaValues = {
                    [tag.attrName]: tag.name,
                    content: tag.value,
                };
                return <meta key={i} {...metaValues} />;
            } else if (tag.type === "title") {
                return <title key={i}>{tag.value}</title>;
            } else if (tag.type === "link") {
                return <link key={i} rel={tag.rel || ""} href={tag.value} />;
            } else if (tag.type === "pagemap") {
                // N/A for the POC since it requires XML within HTML comments
                return null;
            }
            return null;
        });
    }
}
